import { render, staticRenderFns } from "./ProcessCharacteristics.vue?vue&type=template&id=cf9df0a0&scoped=true"
import script from "./ProcessCharacteristics.vue?vue&type=script&lang=js"
export * from "./ProcessCharacteristics.vue?vue&type=script&lang=js"
import style0 from "./ProcessCharacteristics.vue?vue&type=style&index=0&id=cf9df0a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9df0a0",
  null
  
)

export default component.exports